import * as React from "react";
import { CloseButton } from "../CloseButton";
import { EventErrorModel } from "../../data";

export class ErrorMessage extends React.Component<{
    error: EventErrorModel
}, {}> {

    render() {
        return (
            <div className="rj-pulse-bet-markets__error-message">
                <span className="rj-pulse-bet-markets__error-message-text" dangerouslySetInnerHTML={{ __html: this.props.error.message }}></span>
                <CloseButton handler={this.props.error.handler} />
            </div>
        )
    }
}
